import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'fo-arrow',
  template: '',
  styleUrls: ['./style.scss'],
})
export class ArrowComponent {}
